import { Button } from "@/components/ui/button";
import { Printer, X } from "lucide-react";
import { mediaLabelOf } from "@/lib/tagMedia";

// Run-scoped remainder banner — the same mechanism as the Make Tags batch recovery:
// an interrupted run knows EXACTLY which labels never went out, so offer to print
// just those. MEDIA-LOCKED: the remainder replays the ZPL built for the ORIGINAL run
// and routes to that stock's printer, no matter what the picker says now.
export function PrintRemainderBanner({ remainder, onPrint, onDismiss, busy = false }) {
  if (!remainder || !remainder.labels?.length) return null;
  const n = remainder.labels.length;
  const mediaNote = remainder.media ? ` · ${mediaLabelOf(remainder.media)} stock` : "";
  return (
    <div data-testid="print-remainder-banner" className="flex flex-wrap items-center gap-2 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg text-amber-900">
      <span className="text-xs font-semibold" data-testid="print-remainder-text">
        {remainder.title}: {n} label{n === 1 ? "" : "s"} never printed{mediaNote}.
      </span>
      <div className="ml-auto flex items-center gap-2">
        <Button size="sm" data-testid="print-remainder-go" disabled={busy} onClick={onPrint}
                className="h-7 rounded-lg bg-[#B01E28] hover:bg-[#8E1820] text-white text-xs">
          <Printer className="w-3.5 h-3.5 mr-1" />Print remaining {n}
        </Button>
        <button type="button" data-testid="print-remainder-dismiss" onClick={onDismiss} className="text-amber-700 hover:text-amber-900" title="Dismiss — the unprinted labels stay unprinted/unknown">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
